import memoize from 'fast-memoize'

const mirror = <T>(obj: T): T => obj
export const memMirror = memoize(mirror)

export const createCancellableCallback = <T extends (...args: any[]) => any>(fn: T) => {
  let isCancelled = false
  const _fn = (...args: Parameters<T>) => {
    if (!isCancelled) fn(...args)
  }
  _fn.cancel = () => {
    isCancelled = true
  }
  return _fn
}

export { memoize }
